import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../../store/actions/workLocationActions";
import { XMarkIcon } from "@heroicons/react/20/solid";
import Map, { Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import { NotificationManager } from "react-notifications";
import { useMemo } from "react";

//Coordinates to fall back to when location permissions are not granted
const DEFAULT_COORDS = {
	MT: {
		latitude: 35.886826,
		longitude: 14.443147,
	},
	UK: {
		latitude: 52.48444,
		longitude: -1.891284,
	},
};

//Properties of getting the location
const locationOptions = {
	enableHighAccuracy: true,
	timeout: 5000,
	maximumAge: 0,
};

const WorkLocationPinModal = ({
	modalStatus,
	closeModal,
	saveLngLat,
	modalWorkLocation,
	workLocationIndex,
	jurisdiction,
}) => {
	const [pos, setPos] = useState({});
    //Used to check when the state of the geolocation changes, example: "Granted", "Prompted", "Denied"
	const [hasGeoLocationPerms, setGeoLocationPerms] = useState();
	const [coords, setCoords] = useState({
		latitude: null,
		longitude: null,
	});

    // console.debug(`Latitude ${coords.latitude} Longitude ${coords.longitude}`);

	//Seet coordinates to current location if getting location is succesful
	function locationSuccess(position) {
		setCoords({
			latitude: position.coords.latitude,
			longitude: position.coords.longitude,
		});
		// console.debug(`Latitude ${coords.latitude} Longitude ${coords.longitude}`);
	}

	//Throw error code if getting location fails
	function locationError(error) {
		console.warn(`ERROR(${error.code}): ${error.message}`);
	}

	useEffect(() => {
		setPos(workLocationIndex?.pos);
	}, [workLocationIndex?.pos]);
	const mapName = "Buddy_OpenData";
	const apiKey =
		"v1.public.eyJqdGkiOiIwZjA1YmQ2NC1iZmEwLTQwNTEtOTZkMS1jODBhYjhkM2IwZTcifYTulQ5JNcL8JF7DtVapQdQqywfmfIwJdVX_qUHSzXtJuCwVaLGM85lmAMJoNYdNRVP927QfU4RYUAXzTrwSgzf66TAHfiJ6G1_z2JvJ1b5jRNSou4jY7daNOx7JuMQy3SJelse03B1iZmgr0NRZPNsYDlRdBJN3wgI_7B7B3T3w3fDl-ygoJYpugEkjx_vfqI8G7koAyKUoV0Bo7crEpoikLRszAYOu1l0WrHUYmJ8Fnql60IguAP04aSLTaDqs-D6vQVsa4zlc1OW24MBWzUmXeUtN87NFye68QPyQSHzAqfOpKdIItZlOn8Kc0xMtgUEHcGW4XSfI77Ov3T6qT3w.Y2MzMTcwNWYtZTgwMy00NGZlLWFiNGItNzVkMDFmMDM0Nzcy";
	const region = "eu-central-1";
	const mapBoxToken = "pk.eyJ1IjoiYnVkZHlociIsImEiOiJjbGhvb2o4Y3MxeHoyM2dwaDcxa2RhaDR3In0.bcAyhbBBl4Ouag-upW7Vhg";
    
    //Get current location on page load
	useEffect(() => {
        navigator.permissions.query({ name: "geolocation" }).then((result) => {
            setGeoLocationPerms(result.state);
            navigator.geolocation.getCurrentPosition(locationSuccess, locationError, locationOptions);
        });
	}, []);

	// console.debug(hasGeoLocationPerms);

    //Get current location whenever hasGeoLocationPerms updates and on page load
	useEffect(() => {
		if (hasGeoLocationPerms === "granted" || hasGeoLocationPerms === "prompt") {
			navigator.geolocation.getCurrentPosition(locationSuccess, locationError, locationOptions);
		} else {
			setCoords({
				latitude: DEFAULT_COORDS[jurisdiction].latitude,
				longitude: DEFAULT_COORDS[jurisdiction].longitude,
			});
		}
	}, [hasGeoLocationPerms, modalStatus]);

	if (!modalStatus) return null;

	return (
		<div
			className="modal"
			tabIndex="-1"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div
				className="modal-dialog"
				style={{ width: "60%" }}
			>
				<div className="modal-content">
					<div
						className="block block-themed block-transparent remove-margin-b"
						style={{ padding: 0 }}
					>
						<div
							className="block-header bg-primary-dark"
							style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}
						>
							<h3 className="block-title">Pin the work location for {workLocationIndex?.name}</h3>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={() => {
											setPos({});
											closeModal();
										}}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
						</div>
						<div
							className="block-content"
							style={{ margin: 20, overflow: "hidden" }}
						>
							<Map
								initialViewState={{
									//Sets to default location if location permissions are not granted
									latitude: workLocationIndex?.pos?.lat || coords.latitude,
									longitude: workLocationIndex?.pos?.lng || coords.longitude,
									zoom: 11,
								}}
								style={{ width: "100%", height: 400 }}
								mapStyle={`https://maps.geo.${region}.amazonaws.com/maps/v0/maps/${mapName}/style-descriptor?key=${apiKey}`}
								mapboxAccessToken={mapBoxToken}
							>
								<Marker
									latitude={pos?.lat || coords.latitude}
									longitude={pos?.lng || coords.longitude}
									draggable="true"
									onDragEnd={(event) => {
										setPos(event.lngLat);
									}}
								></Marker>
							</Map>
							<div className="clearfix"></div>
						</div>
						<button
							className="btn btn-success pull-right"
							style={{ margin: 10 }}
							onClick={() => {
								if (pos?.lng) {
									saveLngLat(modalWorkLocation, pos);
									closeModal();
								} else {
									NotificationManager.error("You need to select a new location to save");
								}
							}}
						>
							Pin
						</button>
						<div className="clearfix"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		jurisdiction: state.company?.settings?.jurisdiction,
		modalStatus: state.workLocation?.workLocationPinModal,
		modalWorkLocation: state.workLocation?.modalWorkLocation,
		workLocationIndex:
			state.workLocation?.workLocationSettings?.types[
				state.workLocation?.types?.findIndex((item) => item.id == state.workLocation?.modalWorkLocation)
			],
	};
};
const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.setWorkLocationPinModal()),
	saveLngLat: (workLocationId, pos) => dispatch(ACTIONS.setWorkLocationPin(workLocationId, pos)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkLocationPinModal);
